<template>
  <div class="main-frame">
    <div class="info-frame">
      <van-nav-bar title="SMOK" class="top_bar" fixed>
        <template #title>
          <img class="logo-img" src="../assets/image/smoklogo.png" />
        </template>
      </van-nav-bar>
      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 等待 -->
      <van-loading class="spin-load" size="40px" type="spinner" vertical>
        <p>Loading...</p>
      </van-loading>
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import Fingerprint2 from "fingerprintjs2";

import foot from "@/components/Foot.vue";
export default {
  components: {
    foot,
  },
  name: "loading",
  data() {
    return {
      code: "",
      id: "",
    };
  },
  methods: {
    getId: function () {
      // 获取唯一id
      let _me = this;
      let options = {};
      Fingerprint2.get(options, function (components) {
        let values = components.map(function (component) {
          return component.value;
        });
        let murmur = Fingerprint2.x64hash128(values.join(""), 83777975);
        _me.id = murmur;
      });
    },
    onCopy(e) {
      // console.log(e.text);
      this.$notify({ type: "success", message: this.$t("message.copy_a_success") });
    },
    onError(e) {
      // console.log(e);
      this.$notify(this.$t("message.copy_a_fail"));
    },
    getainfo() {
      let _me = this;
      // alert(_me.id);
      let params = {
        // eslint-disable-next-line no-undef
        access_key: ACCESS_KEY,
        device: _me.id,
        info_code: _me.code,
        // eslint-disable-next-line no-undef
        type: TYPE,
      };
      this.common
        .httpPost("anti/fake/info/new", params)
        .then((res) => {
          _me.$toast.clear();
          // console.log(res);
          // 获取语言
          let text = res.data.message;
          if (res.data.status == 852003) {
            // 产品不是正品 ✔️
            _me.$router.push({ name: "A_fake", params: { text: text, code: _me.code } });
          } else if (res.data.status == 852007) {
            // 骷颅头 ✔️
            _me.$router.push({
              name: "ABlackList",
              params: { text: text, code: _me.code },
            });
          } else if (res.data.status == 852006) {
            // 产品未激活 ✔️
            res.data.fake.device_uuid = _me.id;
            _me.$router.push({
              name: "A_nonactivate",
              params: { data: res.data.fake },
            });
          } else if (res.data.status == 852008) {
            // 产品已激活 - 本人查询
            _me.$router.push({
              name: "A_activate",
              params: { data: res.data.fake, status: 1 },
            });
          } else if (res.data.status == 852005) {
            // 产品已激活 - 非本人查询
            _me.$router.push({
              name: "A_activate",
              params: { data: res.data.fake, status: 2 },
            });
          } else if (res.data.status == 852004) {
            // 产品无记录 ✔️
            _me.$router.push({
              name: "A_nonrecord",
              params: { text: text, code: _me.code },
            });
          } else {
            // 统一弹窗提醒
            _me.$notify(text);
            _me.$router.push({ name: "bind-home" });
          }
        })
        .catch((err) => {
          _me.$notify("Web Error:", err.toString());
          // console.log(err);
          _me.$router.push({ name: "bind-home" });
        });
    },
    toHome() {
      this.$router.push({ name: "bind-home" });
    },
  },
  created() {
    if (this.$route.params.code != undefined) {
      if (this.$route.params.code.length == 32) {
        this.code = this.$route.params.code;
        this.getId();
      } else {
        this.$notify(this.$t("message.home_model_not_scanner_code_a"));
        this.$router.push({ name: "bind-home" });
      }
    } else {
      this.$notify(this.$t("message.home_model_not_scanner_code_a"));
      this.$router.push({ name: "bind-home" });
    }
  },
  watch: {
    // eslint-disable-next-line
    id: function (val, oldVal) {
      this.getainfo();
    },
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top_bar {
  height: 54px;
}

.logo-img {
  margin-top: 4px;
  height: 24px;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.spin-load {
  margin-top: 200px;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
